export enum RoutesPath {
   HOME = '/',
   ABOUT = '/about',
   PROJECTS = '/projects',
   CONTACT = '/contact',
}
